import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ClaimSubmissionType } from 'services/MedicalBillingConstants';

export interface SocketClaim {
    referral_id: string;
    payer_id: string;
    supplier_npi: string;
    transaction_id: string;
    submission_type: ClaimSubmissionType;
}

export interface ClaimSummary {
    transactionId: string;
    submissionType: ClaimSubmissionType;
    payerId: string;
    referralId: string;
    supplierNpi: string;
}

export interface ClaimsListSliceState {
    claimsData: ClaimSummary[];
    claimsDataLoaded: boolean;
}

const initialState: ClaimsListSliceState = {
    claimsData: [],
    claimsDataLoaded: false,
};

export const claimsListSlice = createSlice({
    name: 'claimsList',
    initialState,
    reducers: {
        updateClaimsData(state, action: PayloadAction<{ claims: SocketClaim[] }>) {
            const { claims } = action.payload;

            const incomingClaims = claims.map((claim) => ({
                transactionId: claim.transaction_id,
                submissionType: claim.submission_type,
                payerId: claim.payer_id,
                referralId: claim.referral_id,
                supplierNpi: claim.supplier_npi,
            }));

            // Update claims that exist and append new ones
            const claimsToUpdate: Record<string, ClaimSummary> = {};
            const newClaims: ClaimSummary[] = [];
            incomingClaims.forEach((incomingClaim) => {
                if (
                    state.claimsData.find(
                        (existingClaim) =>
                            incomingClaim.transactionId === existingClaim.transactionId,
                    )
                ) {
                    claimsToUpdate[incomingClaim.transactionId] = incomingClaim;
                } else {
                    newClaims.push(incomingClaim);
                }
            });

            return {
                ...state,
                claimsData: [
                    ...state.claimsData.map(
                        (claim) => claimsToUpdate[claim.transactionId] ?? claim,
                    ),
                    ...newClaims,
                ],
                claimsDataLoaded: true,
            };
        },
    },
});

export const { updateClaimsData } = claimsListSlice.actions;
